import { render, staticRenderFns } from "./dependencia.vue?vue&type=template&id=346654ab"
import script from "./dependencia.vue?vue&type=script&lang=js"
export * from "./dependencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports